import React, {useEffect} from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import * as paths from '../../util/paths';
import {BreadcrumbGroup, Button} from '@amzn/awsui-components-react';
import {MY_TEST_ITEM_1, TestRequest} from './model/TestRequest';
import EditTestRequestModal from './components/EditTestRequestModal';
import {TestingStatus} from './model/TestingStatus';
import CreateNewTestRequestModal from './components/CreateNewTestRequestModal';
import Header from '@amzn/awsui-components-react/polaris/header';
import ViewDetailsDashboard from './components/ViewDetailsDashboard';

export default function ViewDetailsForSingleRequest(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [showEditItemModal, setShowEditItemModal] = React.useState(false);
    const [showCopyModal, setShowCopyModal] = React.useState(false);
    const [testRequest, setTestRequest] = React.useState({} as TestRequest);

    // set testRequest as soon as component loads
    useEffect(() => {
        setTestRequest(getRequest());
    }, []);

    const getRequest = () : TestRequest => {
        let request: TestRequest;

        if (props.request) {
            request = props.request;
        }
        else if (props.location.state) {
            request = props.location.state.request;
        }
        else {
            const requestIdFromUrl = props.match.params.request_id;

            // TODO - DB call here
            console.log("Simulating fetching from DB: " + requestIdFromUrl);
            // TODO - get output of DB call here
            request = MY_TEST_ITEM_1;
        }

        return request;
    }

    const getRequestName = () => {
        return "Request - " + testRequest.userLogin + " | " + testRequest.testPurpose;
    }

    const onEditButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        setShowEditItemModal(true);
    }

    const onCopyButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        setShowCopyModal(true);
    }

    const onDownloadButtonClick = (event: CustomEvent) => {
        event.preventDefault();
    }

    const isAlreadyInTerminalState = () => {
        if (testRequest) {
            return TestingStatus.Complete === testRequest.currentStatus;
        }
        else {
            return false;
        }
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <BreadcrumbGroup
                    items={[
                        { text: "Testing Home", href: paths.getRelativePath(paths.MANUAL_TESTING) },
                        { text: "Requests", href: paths.getRelativePath(paths.MANUAL_TESTING_USER_REQUESTS) },
                        { text: getRequestName(), href: paths.getRelativePath(paths.MANUAL_TESTING_VIEW_CURRENT_REQUEST).replace(':request_id', testRequest.identifier) },
                    ]}
                    ariaLabel="Breadcrumbs"
                />
                <Header variant='awsui-h1-sticky'>
                    <SpaceBetween size="xs" direction="horizontal">
                        <Button onClick={onEditButtonClick} disabled={isAlreadyInTerminalState()}> Edit Status </Button>
                        <Button onClick={onCopyButtonClick}> Copy To New </Button>
                        <Button variant='primary' onClick={onDownloadButtonClick}> Download Results </Button>
                    </SpaceBetween>
                    <EditTestRequestModal isVisible={showEditItemModal} setVisible={setShowEditItemModal} currentRequest={testRequest}/>
                    {/*// FIXME - pass the testRequest state to create-new component so that it can copy the fields before saving to DDB*/}
                    <CreateNewTestRequestModal isVisible={showCopyModal} setVisible={setShowCopyModal} operation={'copy'} />
                </Header>
                <Box>
                    <ViewDetailsDashboard request={testRequest} />
                </Box>
            </SpaceBetween>}

        </Box>
    );
}